import { useEffect } from "react";
import { observeTriageThreadDeps } from "~/actions/notification";
import { useClientEnvironment } from "~/environment/ClientEnvironmentContext";

/**
 * Preloads the cache for a triageThread action so that the action is snappy.
 */
export function usePreloadTriageThreadDeps(props: { threadId: string | null | undefined }) {
  const environment = useClientEnvironment();

  useEffect(() => {
    if (!props.threadId) return;
    const sub = observeTriageThreadDeps(environment, { threadId: props.threadId }).subscribe();
    return () => sub.unsubscribe();
  }, [props.threadId, environment.recordLoader, environment.auth]);
}
